export function setUrl(url) {
  window.history.pushState({}, '', url)
}

export function setUrlParams(name, value) {
  const url = new URL(window.location.href)
  url.searchParams.set(name, value)
  setUrl(url)
}

export function getPath() {
  return window.location.pathname
}

export function getPathWithParams() {
  return getPath() + window.location.search
}

export function removeQuery(str) {
  const cutoff = str.indexOf('?')
  if (cutoff === -1) return str
  return str.substring(0, cutoff)
}
